import React from "react";
import {
  FaLightbulb,
  FaProjectDiagram,
  FaPalette,
  FaFileContract,
  FaCube,
  FaRocket,
} from "react-icons/fa";

function ConceptualizationNFT() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our Approach For NFT Development
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  The NFT development process involves several key stages that
                  transform your concept into a fully functional non-fungible
                  token, ready for deployment on the blockchain. Here's an
                  overview of the steps involved:
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaLightbulb size={35} />
                  </div>
                  <h4>Conceptualization & Consultation</h4>
                  <p>
                    The process begins with understanding your vision and
                    objectives for the NFT project. Whether you’re creating
                    digital art, tokenizing real-world assets, or building an
                    NFT-based platform, we work with you to refine the idea and
                    outline the technical requirements.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaProjectDiagram size={35} />
                  </div>
                  <h4>Blockchain Selection</h4>
                  <p>
                    Based on your project’s needs, we help you select the most
                    suitable blockchain network (e.g., Ethereum, Binance Smart
                    Chain, Solana, Polygon). This decision depends on factors
                    like transaction speed, cost, scalability, and the target
                    audience.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaPalette size={35} />
                  </div>
                  <h4>NFT Design & Metadata Creation</h4>
                  <p>
                    Our team collaborates with you to design custom NFTs,
                    focusing on the visual elements, asset attributes, and
                    metadata (information that defines the NFT’s unique
                    properties, such as its name, description, and traits). This
                    ensures your NFTs are one-of-a-kind and recognizable.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaFileContract size={35} />
                  </div>
                  <h4>Smart Contract Development</h4>
                  <p>
                    We develop secure, tamper-proof smart contracts that handle
                    the minting, ownership transfers, and other functionalities
                    of your NFTs. We ensure compliance with leading token
                    standards like ERC-721, ERC-1155, or other relevant
                    protocols.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaCube size={35} />
                  </div>
                  <h4>NFT Minting</h4>
                  <p>
                    Once the design and smart contract are ready, the NFTs are
                    minted (created) on the chosen blockchain. Each minted NFT
                    is linked to its corresponding metadata and becomes a
                    verifiable digital asset that can be traded, sold, or
                    transferred.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaRocket size={35} />
                  </div>
                  <h4>Launch & Support</h4>
                  <p>
                    After successful testing, your NFTs are deployed to the
                    blockchain and made available to the public. We provide
                    post-launch support to ensure smooth operation and address
                    any issues that arise.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConceptualizationNFT;
